import { HfsSettingsActionEnum } from 'fleet-data-model';
import { type Update } from '../../types';

export const mapFrostSensorEnabledExecutionTargets = (update: Update) => {
  return [
    {
      hfsActionId: HfsSettingsActionEnum.FROST_SENSOR_ENABLED,
      iprId: update.assetId,
      payload: {
        enabled: update.enabled,
      },
    },
  ];
};
